import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Container } from "reactstrap";
import { AuthNavbar } from "../core";
import routesService from "../service/routeService";
import { getUserProfile } from "../service/auth";

const AuthLayout = ({ component: Component }) => {
	let navigate = useNavigate();
	let [flag, setFlag] = useState(true);
	useEffect(() => {
		try {
			let userProfile = getUserProfile();
			if (userProfile?.token) return navigate(routesService.getHomePageRoute());
			setFlag(false);
		} catch (error) {}
	}, [navigate]);
	if (flag) return <></>;
	return (
		<Fragment>
			<AuthNavbar />
			<Container fluid className="main-content-height main-content-overflow">
				<Component />
			</Container>
		</Fragment>
	);
};

export default AuthLayout;
